import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { standardAsyncConnect } from 'utils/asyncConnectWrapper';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import Tabs from 'modules/Common/components/Tabs';
import MyStableSearch from '../components/MyStableSearch';

import { userServiceLayoutConnect } from 'modules/Common/reducers/userService';

@catchLifeCycleErrors
@standardAsyncConnect([
  userServiceLayoutConnect({
    state: state => ({auth: state.common.auth})
  })
])
export default class MyStablePageContainer extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    dispatch: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired
  }

  isLoggedIn = () => {
    return this.props.auth && this.props.auth.loggedIn && this.props.auth.user;
  }

  render() {
    require("../components/MyStable.scss");
    const { isLoggedIn, props: { router, dispatch, children } } = this;

    return (
      <div className="my-stable-container">
        <div className="my-stable-title">
          <h1 className="page-title">My Stable</h1>
          <MyStableSearch {...{dispatch, router}} />
        </div>
        <Tabs tabs={[
          {href: '/racing/my-stable', text: 'Next Entries', isIndex: true},
          {href: '/racing/my-stable/results', text: 'Results'},
          {href: '/racing/my-stable/selections', text: 'Selections'},
          {href: '/racing/my-stable/search', text: 'Search'}
        ]}/>
        <div>{React.cloneElement(children, {isLoggedIn})}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStablePageContainer.js